// removed by extract-text-webpack-plugin
module.exports = {"Preloader":"Preloader","visible":"visible"};


//////////////////
// WEBPACK FOOTER
// ./src/components/preloader/styles.css
// module id = 905
// module chunks = 0 1